import React from 'react';

export function Separator(props) {
  let styles = 'h-1 b-0 bb-1 b-coolGrayLightest my-m';
  if (props.styles) {
    styles = styles.concat(' ', props.styles);
  }
  return <div className={styles} />;
}



// WEBPACK FOOTER //
// ./src/components_new/Separator.js